import { render, staticRenderFns } from "./CosmoformTemplate.vue?vue&type=template&id=7d101780&scoped=true"
import script from "./CosmoformTemplate.vue?vue&type=script&lang=js"
export * from "./CosmoformTemplate.vue?vue&type=script&lang=js"
import style0 from "./CosmoformTemplate.vue?vue&type=style&index=0&id=7d101780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d101780",
  null
  
)

export default component.exports